import { Link } from "react-router-dom"
import QuantityControl from "../helper/QuantityControl"
import { removeFromCart } from "../features/cart/cartSlice"
import { useDispatch } from "react-redux"

const CartList = ({item}) => {
    const dispatch = useDispatch();

    function handleCartRemove() {
        dispatch(removeFromCart(item?.id))
    }
    
    return (
        <tr>
            <td>
                <button
                    type="button"
                    className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                    onClick={handleCartRemove}
                >
                    <i className="ph ph-x-circle text-2xl d-flex" />
                    Remove
                </button>
            </td>
            <td>
                <div className="table-product d-flex align-items-center gap-24">
                    <Link
                        to="/product-details-two"
                        className="table-product__thumb border border-gray-100 rounded-8 flex-center "
                    >
                        <img
                            src="assets/images/thumbs/product-two-img1.png"
                            alt=""
                        />
                    </Link>
                    <div className="table-product__content text-start">
                        <h6 className="title text-lg fw-semibold mb-8">
                            <Link
                                to="/product-details"
                                className="link text-line-2"
                                tabIndex={0}
                            >
                                {item?.product?.name ? item?.product?.name : ""}
                            </Link>
                        </h6>
                        <div className="flex-align gap-16 mb-16">
                            <div className="flex-align gap-6">
                                <span className="text-md fw-medium text-warning-600 d-flex">
                                    <i className="ph-fill ph-star" />
                                </span>
                                <span className="text-md fw-semibold text-gray-900">
                                    4.8
                                </span>
                            </div>
                            <span className="text-sm fw-medium text-gray-200">
                                |
                            </span>
                            <span className="text-neutral-600 text-sm">
                                128 Reviews
                            </span>
                        </div>
                        <div className="flex-align gap-16">
                            <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                            >
                                Camera
                            </Link>
                            <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                            >
                                Videos
                            </Link>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <span className="text-lg h6 mb-0 fw-semibold">{item?.price ? `৳ ${item?.price}` : ""}</span>
            </td>
            <td>
                <QuantityControl item={item} />
            </td>
            <td>
                <span className="text-lg h6 mb-0 fw-semibold"> {item?.total_price ? `৳ ${item?.total_price}` : ""}</span>
            </td>
        </tr>
    )
}

export default CartList